// extracted by mini-css-extract-plugin
export default {"login":"AuthLayout_login__zqkkz","login-container":"AuthLayout_login-container__itcv8"};